import { loadStateSession } from '../../../../FlyfishComponents/flyfishutils/utils';
import styled from 'styled-components';

export const ProductCardWrapper = styled.a`
	position: relative;
	display: ${() =>
		loadStateSession('deviceType') === 'mobile' ? 'block' : 'inline-block'};
	background: white;
	border-radius: 8px;
	outline: 1px solid rgba(0, 0, 0, 0.1);
	transition: outline 0.6s ease, box-shadow 0.6s ease, transform 0.6s ease,
		filter 0.6s ease;
	width: 100%;
	text-decoration: none;
	&:hover {
		cursor: pointer;
		box-shadow: ${(props) =>
			props.noHover
				? ''
				: '0 12px 24px rgba(0, 0, 0, 0.25), 0 2px 4px rgba(0, 0, 0, 0.25) !important'};
		z-index: 100;
		transform: ${(props) => (props.noHover ? '' : 'scale(1.05)')};
	}

	& > .wishlist {
		border-radius: 50%;
		background: white;
		padding: 4px;
		position: absolute;
		top: 4px;
		right: 4px;
		&:hover {
			box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.16);
		}
	}

	&.center-image {
		& > img {
			min-height: 150px;
		}
		& > .wishlist {
			top: 8px;
			right: 8px;
		}
		// & > .content {
		// 	& > .title {
		// 		font-weight: 600;
		// 	}
		// }
	}
	&.user-image {
		& > img {
			min-height: unset;
		}
		& > .wishlist {
			display: none;
		}
		&:hover {
			cursor: not-allowed !important;
			box-shadow: none !important;
			transform: none !important;
			transition: none !important;
		}
	}
	& > .content {
		&.hide {
			display: none;
		}
		padding: 8px;
		text-align: center;
		& > .price-holder {
			display: flex;
			justify-content: center;
			flex-wrap: wrap;
			& > .price {
				color: var(--neutral-color-ff-neutral500);

				&.line-through {
					text-decoration: line-through;
					margin-left: 6px;
					font-weight: 400;
				}
				&.restore-color {
					color: var(--secondary-color-ff-secondary500);
					font-weight: 500;
				}
			}
			& > .sale-price {
				color: var(--secondary-color-ff-secondary500);
				font-weight: 500;
			}
			& > .discount {
				display: flex;
				align-items: center;
				gap: 4px;
				color: var(--primary-color-ff-primary900);
				font-weight: 400;
				margin-left: 6px;
				margin-top: 1px;
			}
		}

		& > .title {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: ${(props) => (props.noHover ? '1' : '2')};
			overflow: hidden;
			font-size: 0.75em;
			font-weight: 400;
			margin-bottom: 4px;
			color: var(--primary-color-ff-primary900);
			line-height: 1.25;
			&.flashing-text {
				animation: flash-text 1.5s linear infinite;
				text-align: center;
			}
			& > .loader-text {
				display: flex;
				flex-direction: column;
				align-items: center;
				border-radius: 19px;
				& > .ext1,
				& > .ext2 {
					animation: flash-background 1.5s linear infinite;
					background-color: var(--black-10);
					height: 8px;
					width: 100%;
					border-radius: 19px;
				}
				& > .ext2 {
					width: 75px;
					margin-top: 10px;
				}
			}
		}
	}

	& > img {
		aspect-ratio: ${(props) =>
			loadStateSession('productCardAspectRatio')
				? `${loadStateSession('productCardAspectRatio')}`
				: ''};
		min-height: 80px;

		background: var(--neutral-color-ff-neutral100);
		border-top-right-radius: 8px;
		border-top-left-radius: 8px;
		object-fit: contain;
		display: block;
		width: 100%;
		height: auto;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		&:hover {
			cursor: pointer;
		}
	}
	&.left-most-animation,
	&.left-animation,
	&.right-most-animation,
	&.right-animation {
		overflow: hidden;
		width: 100%;
		box-shadow: none !important;
		&:hover {
			cursor: wait;
			transform: scale(1);
		}
		& > .wishlist {
			display: none;
		}
		& > .image-placeholder {
			width: 100%;
			aspect-ratio: ${(props) =>
				loadStateSession('productCardAspectRatio')
					? `${loadStateSession('productCardAspectRatio')}`
					: ''};
			animation: change-background-color 3s linear infinite;
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);
			& > .gradient-animation-diagonal {
				background: linear-gradient(
					135deg,
					rgba(255, 255, 255, 0) 25%,
					rgba(255, 255, 255, 1) 50%,
					rgba(255, 255, 255, 0) 75%
				);
				background-size: 300% 300%;
				animation: move-gradient 1.5s ease infinite;
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 16px;
				text-align: center;
				color: rgba(0, 0, 0, 0.8);

				& > .flashing-text {
					animation: flash-text 1.5s linear infinite;
					text-align: center;
					font-weight: 600;
					line-height: 1.25;
				}
			}
		}
	}
	&.left-most-animation {
		& > .image-placeholder {
			animation-delay: ${(props) =>
				props.animationIndex === 0 ? '-0.75s' : '-1.5s'};
			& > .gradient-animation-diagonal {
				animation-delay: ${(props) =>
					props.animationIndex === 0 ? '-0.75s' : '-1.5s'};
			}
		}
		& > .content {
			& > .flashing-text {
				animation-delay: ${(props) =>
					props.animationIndex === 0 ? '-0.325s' : '-0.75s'};
			}
		}
	}
	&.left-animation {
		& > .image-placeholder {
			animation-delay: ${(props) =>
				props.animationIndex === 0 ? '-3s' : '-2.25s'};
			& > .gradient-animation-diagonal {
				animation-delay: ${(props) =>
					props.animationIndex === 0 ? '-3s' : '-2.25s'};
			}
		}
		& > .content {
			& > .flashing-text {
				animation-delay: ${(props) =>
					props.animationIndex === 0 ? '-1.5s' : '-1.125s'};
			}
		}
	}
	&.right-animation {
		& > .image-placeholder {
			animation-delay: ${(props) =>
				props.animationIndex === 0 ? '-1.5s' : '-2.25s'};
			& > .gradient-animation-diagonal {
				animation-delay: ${(props) =>
					props.animationIndex === 0 ? '-1.5s' : '-2.25s'};
			}
		}
		& > .content {
			& > .flashing-text {
				animation-delay: ${(props) =>
					props.animationIndex === 0 ? '-0.75s' : '-1.125s'};
			}
		}
	}
	&.right-most-animation {
		& > .image-placeholder {
			animation-delay: ${(props) =>
				props.animationIndex === 0 ? '-0.75s' : '-3s'};
			& > .gradient-animation-diagonal {
				animation-delay: ${(props) =>
					props.animationIndex === 0 ? '-0.75s' : '-3s'};
			}
		}
		& > .content {
			& > .flashing-text {
				animation-delay: ${(props) =>
					props.animationIndex === 0 ? '-0.325s' : '-1.5s'};
			}
		}
	}
	@keyframes change-background-color {
		0% {
			background-color: var(--background-animation-color-1);
		}
		25% {
			background-color: var(--background-animation-color-2);
		}
		50% {
			background-color: var(--background-animation-color-3);
		}
		75% {
			background-color: var(--background-animation-color-4);
		}
		100% {
			background-color: var(--background-animation-color-1);
		}
	}

	@keyframes move-gradient {
		0% {
			background-position: left 100% top 100%;
		}
		100% {
			background-position: right 100% bottom 100%;
		}
	}

	@keyframes flash-text {
		0% {
			color: rgba(0, 0, 0, 0.4);
		}
		20% {
			color: rgba(0, 0, 0, 0.2);
		}
		40% {
			color: rgba(0, 0, 0, 0.4);
		}
		100% {
			color: rgba(0, 0, 0, 0.4);
		}
	}
	@keyframes flash-background {
		0% {
			background-color: rgba(0, 0, 0, 0.1);
		}
		20% {
			background-color: rgba(0, 0, 0, 0.2);
		}
		40% {
			background-color: rgba(0, 0, 0, 0.1);
		}
		100% {
			background-color: rgba(0, 0, 0, 0.1);
		}
	}
`;
